{
  "admin.guard": {
    "loading": "Cargando…"
  },
  "admin.layout": {
    "nav": {
      "label": "Principal",
      "home": "Panel",
      "clinics": "Clínicas",
      "staff": "Equipo",
      "profile": "Perfil",
      "password": "Cambiar contraseña"
    },
    "logout": "Salir",
    "logoutFailed": "No se pudo salir. Inténtalo de nuevo."
  },
  "admin.shell": {
    "brand": "Takove",
    "skipToContent": "Saltar al contenido"
  },
  "admin.clinicNew": {
    "title": "Nueva clínica",
    "name": "Nombre de la clínica",
    "timezone": {
      "label": "Zona horaria",
      "hint": "Elige con cuidado: la zona horaria no se puede cambiar después. Un error lo corrige operaciones, solo mientras la clínica no tenga citas.",
      "zone": {
        "saoPaulo": "São Paulo, Rio, Brasília (UTC−3)",
        "noronha": "Fernando de Noronha (UTC−2)",
        "belem": "Belém (UTC−3)",
        "fortaleza": "Fortaleza (UTC−3)",
        "recife": "Recife (UTC−3)",
        "araguaina": "Araguaína (UTC−3)",
        "maceio": "Maceió (UTC−3)",
        "bahia": "Salvador, Bahia (UTC−3)",
        "campoGrande": "Campo Grande (UTC−4)",
        "cuiaba": "Cuiabá (UTC−4)",
        "portoVelho": "Porto Velho (UTC−4)",
        "boaVista": "Boa Vista (UTC−4)",
        "manaus": "Manaus (UTC−4)",
        "eirunepe": "Eirunepé (UTC−5)",
        "rioBranco": "Rio Branco (UTC−5)"
      }
    },
    "owner": {
      "legend": "Responsable (propietario)",
      "kind": "Cuenta del propietario",
      "kindNew": "Nueva cuenta del equipo",
      "kindExisting": "Cuenta del equipo existente",
      "email": "Correo del propietario",
      "emailExistingHint": "La cuenta ya debe existir y estar activa.",
      "name": "Nombre del propietario"
    },
    "cro": {
      "number": "Número del CRO",
      "uf": "UF del CRO",
      "noUf": "UF"
    },
    "submit": "Crear clínica",
    "error": {
      "emailTaken": "Ya existe una cuenta del equipo con este correo.",
      "ownerNotFound": "No existe una cuenta del equipo con este correo.",
      "ownerDisabled": "Esta cuenta del equipo está desactivada.",
      "croPair": "Indica el número y la UF del CRO, o deja ambos vacíos.",
      "generic": "No se pudo crear la clínica. Inténtalo de nuevo."
    }
  },
  "admin.clinic": {
    "back": "Todas las clínicas",
    "created": "Clínica {{name}} creada.",
    "createdNewOwner": "Como el propietario es una cuenta nueva, genera su enlace de contraseña en Equipo.",
    "statusTitle": "Estado",
    "createdAt": "Creada el {{date}}",
    "closedSince": "Cerrada desde {{date}}. Los miembros solo consultan; no se borró nada.",
    "suspendedSince": "Suspendida desde {{date}}. Los miembros no pueden acceder a la clínica.",
    "action": {
      "close": "Cerrar clínica",
      "reopen": "Reabrir clínica",
      "suspend": "Suspender clínica",
      "unsuspend": "Levantar suspensión"
    },
    "reason": {
      "closeTitle": "Cerrar clínica",
      "suspendTitle": "Suspender clínica",
      "label": "Motivo",
      "hint": "Queda registrado en la auditoría.",
      "confirmClose": "Confirmar cierre",
      "confirmSuspend": "Confirmar suspensión",
      "cancel": "Cancelar",
      "required": "Indica el motivo."
    },
    "done": {
      "closed": "Clínica cerrada.",
      "reopened": "Clínica reabierta.",
      "suspended": "Clínica suspendida.",
      "unsuspended": "Suspensión levantada."
    },
    "error": {
      "load": "No se pudo cargar la clínica. Inténtalo de nuevo.",
      "notFound": "Clínica no encontrada.",
      "action": "No se pudo completar la acción. Inténtalo de nuevo."
    }
  },
  "admin.clinics": {
    "title": "Clínicas",
    "new": "Nueva clínica",
    "search": "Buscar por nombre",
    "searchSubmit": "Buscar",
    "empty": "Aún no hay clínicas.",
    "emptySearch": "Ninguna clínica coincide con la búsqueda.",
    "hasMore": "Hay más clínicas de las mostradas. Afina la búsqueda.",
    "col": {
      "name": "Nombre",
      "status": "Estado",
      "members": "Miembros",
      "created": "Creada el"
    },
    "status": {
      "active": "Activa",
      "closed": "Cerrada",
      "suspended": "Suspendida"
    },
    "error": {
      "load": "No se pudieron cargar las clínicas. Inténtalo de nuevo."
    }
  },
  "admin.clinicIdentity": {
    "title": "Identidad de la clínica",
    "hint": "Solo el propietario de la clínica edita estos datos; aquí solo se consultan.",
    "notInformed": "No informado",
    "whatsapp": "WhatsApp",
    "cro": "CRO {{number}}/{{uf}}",
    "croNoUf": "CRO {{number}}",
    "fields": {
      "legalName": "Razón social",
      "cnpj": "CNPJ",
      "croRegistration": "Registro CRO de la clínica",
      "phone": "Teléfono",
      "email": "Correo electrónico",
      "address": "Dirección",
      "technicalManager": "Responsable técnico"
    }
  },
  "admin.clinicMembers": {
    "title": "Miembros activos",
    "empty": "Esta clínica no tiene miembros activos.",
    "col": {
      "name": "Nombre",
      "email": "Correo",
      "roles": "Roles",
      "since": "Desde",
      "actions": "Acciones"
    },
    "role": {
      "owner": "Propietario",
      "dentist": "Dentista"
    },
    "technicalManager": "Responsable técnico",
    "action": {
      "roles": "Cambiar roles",
      "rolesFor": "Cambiar roles de {{name}}",
      "end": "Terminar vínculo",
      "endFor": "Terminar vínculo de {{name}}",
      "setTm": "Definir como responsable técnico",
      "setTmFor": "Definir como responsable técnico: {{name}}",
      "clearTm": "Quitar responsable técnico",
      "clearTmFor": "Quitar responsable técnico: {{name}}"
    },
    "add": {
      "title": "Añadir miembro",
      "email": "Correo de la cuenta de equipo",
      "emailHint": "La cuenta debe existir. Créala antes en Equipo si hace falta.",
      "roles": "Roles del nuevo miembro",
      "submit": "Añadir miembro"
    },
    "edit": {
      "title": "Cambiar roles de {{name}}",
      "roles": "Roles de {{name}}",
      "save": "Guardar roles",
      "cancel": "Cancelar"
    },
    "end": {
      "title": "Terminar vínculo de {{name}}",
      "body": "La persona pierde el acceso a esta clínica. Se conserva el historial y la cuenta sigue existiendo.",
      "confirm": "Confirmar término",
      "cancel": "Cancelar"
    },
    "done": {
      "added": "{{name}} fue añadido a la clínica.",
      "roles": "Roles de {{name}} actualizados.",
      "ended": "Vínculo de {{name}} terminado.",
      "tmSet": "{{name}} es el responsable técnico.",
      "tmCleared": "{{name}} dejó de ser el responsable técnico."
    },
    "error": {
      "notFound": "No existe una cuenta de equipo con este correo.",
      "disabled": "Esta cuenta está desactivada.",
      "cro": "El rol de dentista exige un CRO en la cuenta.",
      "alreadyMember": "Esta cuenta ya es miembro activo de esta clínica.",
      "lastOwner": "Una clínica debe mantener al menos un propietario activo.",
      "tmIneligible": "El responsable técnico debe ser dentista con CRO.",
      "generic": "No se pudo completar la acción. Inténtalo de nuevo.",
      "futureAppointments_one": "Este miembro tiene {{count}} cita futura. Reasígnela o cancélela antes de continuar.",
      "futureAppointments_many": "Este miembro tiene {{count}} de citas futuras. Reasígnelas o cancélelas antes de continuar.",
      "futureAppointments_other": "Este miembro tiene {{count}} citas futuras. Reasígnelas o cancélelas antes de continuar.",
      "rolesRequired": "Elige al menos un rol."
    }
  },
  "admin.home": {
    "title": "Panel",
    "welcome": "Hola, {{name}}."
  },
  "admin.login": {
    "forgot": "¿Olvidaste la contraseña?",
    "title": "Iniciar sesión",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "submit": "Entrar",
    "passwordSet": "Contraseña definida. Inicia sesión con la nueva contraseña.",
    "error": {
      "invalid": "Correo o contraseña incorrectos.",
      "throttled": "Demasiados intentos. Espera un minuto e inténtalo de nuevo.",
      "generic": "No se pudo iniciar sesión. Inténtalo de nuevo."
    }
  },
  "admin.notFound": {
    "title": "Página no encontrada",
    "message": "La página que buscas no existe o fue movida.",
    "home": "Ir al inicio"
  },
  "admin.password": {
    "title": "Cambiar contraseña",
    "current": "Contraseña actual",
    "new": "Nueva contraseña",
    "confirm": "Confirmar nueva contraseña",
    "submit": "Cambiar contraseña",
    "changed": "Contraseña cambiada. Se cerraron tus otras sesiones.",
    "error": {
      "wrongCurrent": "La contraseña actual es incorrecta.",
      "tooShort": "La nueva contraseña debe tener al menos {{min}} caracteres.",
      "unchanged": "La nueva contraseña debe ser distinta de la actual.",
      "mismatch": "Las contraseñas no coinciden.",
      "throttled": "Demasiados intentos. Espera un minuto e inténtalo de nuevo.",
      "generic": "No se pudo cambiar la contraseña. Inténtalo de nuevo."
    }
  },
  "admin.profile": {
    "title": "Perfil",
    "email": "Correo electrónico",
    "emailHint": "El correo no se puede cambiar aquí.",
    "name": "Nombre",
    "locale": "Idioma",
    "dateFormat": "Formato de fecha",
    "clock": "Reloj",
    "dateFormats": {
      "DMY": "Día/mes/año",
      "MDY": "Mes/día/año",
      "YMD": "Año/mes/día"
    },
    "clocks": {
      "24h": "24 horas",
      "12h": "12 horas"
    },
    "submit": "Guardar",
    "saved": "Perfil guardado.",
    "error": "No se pudo guardar el perfil. Inténtalo de nuevo."
  },
  "admin.staffNew": {
    "title": "Nueva cuenta del equipo",
    "email": "Correo",
    "name": "Nombre",
    "cro": {
      "legend": "Registro en el CRO (opcional)",
      "number": "Número del CRO",
      "uf": "UF del CRO",
      "noUf": "UF"
    },
    "submit": "Crear cuenta",
    "error": {
      "emailTaken": "Ya existe una cuenta del equipo con este correo.",
      "croPair": "Indica el número y la UF del CRO, o deja ambos vacíos.",
      "generic": "No se pudo crear la cuenta. Inténtalo de nuevo."
    }
  },
  "admin.staff": {
    "title": "Cuentas del equipo",
    "new": "Nueva cuenta",
    "created": "Cuenta de {{name}} creada. Genera el enlace para definir la contraseña y entrégaselo.",
    "search": "Buscar por nombre o correo",
    "searchSubmit": "Buscar",
    "empty": "Aún no hay cuentas del equipo.",
    "emptySearch": "Ninguna cuenta coincide con la búsqueda.",
    "hasMore": "Hay más cuentas de las mostradas. Afina la búsqueda.",
    "col": {
      "name": "Nombre",
      "email": "Correo",
      "cro": "CRO",
      "status": "Estado",
      "lastLogin": "Último acceso",
      "actions": "Acciones"
    },
    "status": {
      "active": "Activa",
      "pending": "Esperando contraseña",
      "disabled": "Desactivada"
    },
    "action": {
      "link": "Generar enlace de contraseña de {{name}}",
      "disable": "Desactivar {{name}}",
      "enable": "Reactivar {{name}}"
    },
    "link": {
      "title": "Enlace de contraseña de {{name}}",
      "hint": "Entrega este enlace a la persona. Se muestra solo ahora, sirve una vez y vence el {{expires}}. Generar otro enlace anula este.",
      "choose": "¿Cómo debe recibir {{name}} el enlace? Generar un enlace nuevo anula el anterior.",
      "email": "Enviar por correo",
      "sent": "Enlace enviado a {{email}}, válido hasta {{expires}}.",
      "sentHint": "Si no llega, genera un nuevo enlace con Copiar enlace: anula el enviado.",
      "close": "Cerrar",
      "label": "Enlace",
      "copy": "Copiar enlace",
      "copied": "Enlace copiado."
    },
    "confirm": {
      "title": "¿Desactivar a {{name}}?",
      "future_one": "{{name}} tiene {{count}} cita futura. Desactivar la cuenta no la cancela ni la reasigna: sigue en la agenda sin profesional que la atienda. Reasígnela o cancélela antes, o desactive igualmente.",
      "future_many": "{{name}} tiene {{count}} de citas futuras. Desactivar la cuenta no las cancela ni las reasigna: siguen en la agenda sin profesional que las atienda. Reasígnelas o cancélelas antes, o desactive igualmente.",
      "future_other": "{{name}} tiene {{count}} citas futuras. Desactivar la cuenta no las cancela ni las reasigna: siguen en la agenda sin profesional que las atienda. Reasígnelas o cancélelas antes, o desactive igualmente.",
      "submit": "Desactivar igualmente",
      "cancel": "Cancelar"
    },
    "error": {
      "load": "No se pudieron cargar las cuentas. Inténtalo de nuevo.",
      "action": "No se pudo completar la acción. Inténtalo de nuevo."
    }
  },
  "hub.guard": {
    "loading": "Cargando…"
  },
  "hub.layout": {
    "clinicNav": "Clínica",
    "patients": "Pacientes",
    "agenda": "Agenda",
    "settings": "Configuración",
    "logout": "Salir",
    "logoutFailed": "No se pudo salir. Inténtalo de nuevo.",
    "switchClinic": "{{name}}, cambiar de clínica",
    "allClinics": "Todas las clínicas"
  },
  "hub.shell": {
    "brand": "Takove",
    "skipToContent": "Saltar al contenido"
  },
  "hub.agenda": {
    "title": "Agenda",
    "subtitle": "Las citas de la clínica por día o por semana.",
    "loading": "Cargando la agenda…",
    "loadFailed": "No se pudo cargar la agenda.",
    "retry": "Intentar de nuevo",
    "noAccess": "No tienes acceso a la agenda de esta clínica.",
    "weekday": {
      "1": "Lunes",
      "2": "Martes",
      "3": "Miércoles",
      "4": "Jueves",
      "5": "Viernes",
      "6": "Sábado",
      "7": "Domingo"
    },
    "toolbar": {
      "label": "Opciones de la agenda",
      "view": "Vista",
      "day": "Día",
      "week": "Semana",
      "professional": "Profesional",
      "allProfessionals": "Toda la clínica",
      "today": "Hoy",
      "prevDay": "Día anterior",
      "nextDay": "Día siguiente",
      "prevWeek": "Semana anterior",
      "nextWeek": "Semana siguiente",
      "new": "Nueva cita",
      "schedule": "Horarios y bloqueos",
      "rebooking": "Reagendamientos pendientes",
      "mode": "Modo de vista",
      "grid": "Cuadrícula",
      "list": "Lista",
      "rangeDay": "{{from, date}}",
      "rangeWeek": "{{from, date}} a {{to, date}}"
    },
    "filter": {
      "warningsOnly": "Mostrar solo citas con avisos",
      "warningCount_one": "{{count}} con aviso",
      "warningCount_other": "{{count}} con avisos"
    },
    "list": {
      "label": "Agenda del período",
      "dayHeading": "{{weekday}}, {{date, date}}",
      "today": "Hoy",
      "closed": "Clínica cerrada",
      "emptyDay": "Sin citas",
      "noWarnings": "Ninguna cita con aviso en este período.",
      "range": "{{start, time}} – {{end, time}}",
      "sentence": "{{patient}}, {{start, time}} a {{end, time}}, {{professional}}, {{status}}"
    },
    "grid": {
      "corner": "Hora",
      "dayLabel": "Agenda de {{weekday}}, {{date, date}}",
      "weekLabel": "Agenda de la semana de {{name}}, {{from, date}} a {{to, date}}",
      "dateLine": "{{date, date}}",
      "details": "{{professional}}, {{weekday}}, {{date, date}}, {{start, time}} a {{end, time}}",
      "newSlot": "Nueva cita, {{professional}}, {{weekday}}, {{date, date}}, {{time, time}}",
      "slotClosed": "fuera del horario de la clínica",
      "slotOff": "fuera del horario de trabajo del profesional",
      "notes": "Bloqueos del período",
      "noteLine": "{{date, date}}: {{note}}",
      "summaryLabel": "Resumen de la semana: citas por profesional y día",
      "summaryHint": "Elige un profesional para ver la semana en cuadrícula, o abre un día.",
      "summaryProfessional": "Profesional",
      "summaryCell_one": "{{professional}}, {{weekday}}, {{date, date}}: {{count}} cita. Abrir el día",
      "summaryCell_other": "{{professional}}, {{weekday}}, {{date, date}}: {{count}} citas. Abrir el día"
    },
    "announce": {
      "shown_one": "{{count}} cita en el período",
      "shown_other": "{{count}} citas en el período",
      "warnings_one": "{{count}} cita con aviso",
      "warnings_other": "{{count}} citas con avisos"
    },
    "status": {
      "scheduled": "Programada",
      "confirmed": "Confirmada",
      "arrived": "Llegó",
      "in_progress": "En atención",
      "completed": "Completada",
      "cancelled": "Cancelada",
      "no_show": "No asistió"
    },
    "flag": {
      "outside_opening_hours": "Fuera del horario",
      "outside_working_hours": "Fuera del horario laboral",
      "in_block": "En bloqueo",
      "outcomePending": "Resultado pendiente",
      "freed": "Horario liberado"
    },
    "block": {
      "clinic": "Clínica cerrada: {{what}}",
      "professional": "Bloqueo de {{name}}: {{what}}",
      "professionalUnknown": "Bloqueo de profesional: {{what}}",
      "inGrid": "Bloqueo: {{what}}",
      "withHours": "{{note}}, {{from, time}} – {{to, time}}",
      "reason": {
        "vacation": "Vacaciones",
        "absence": "Ausencia",
        "training": "Capacitación",
        "holiday": "Feriado",
        "closure": "Cierre",
        "other": "Otro"
      }
    },
    "sheet": {
      "createTitle": "Nueva cita",
      "create": "Crear cita",
      "noProfessionals": "Ningún profesional disponible para recibir citas.",
      "editTitle": "Cita de {{patient}}",
      "close": "Cerrar",
      "summary": {
        "status": "Estado",
        "day": "Día",
        "time": "Horario",
        "professional": "Profesional",
        "patient": "Paciente",
        "reason": "Motivo"
      },
      "statusChanged": "Estado cambiado a {{status}}.",
      "statusGroup": "Cambiar estado",
      "noActions": "No hay cambios de estado disponibles ahora.",
      "cancelGroup": "Motivo de la cancelación",
      "noShowGroup": "Motivo de la inasistencia",
      "reasonLabel": "Motivo",
      "confirmCancel": "Confirmar cancelación",
      "confirmNoShow": "Confirmar inasistencia",
      "back": "Volver",
      "reasonRequired": "Elige un motivo.",
      "moveGroup": "Mover o ajustar",
      "save": "Guardar cambios",
      "frozen": "Esta cita está finalizada: los campos están bloqueados.",
      "viewConflict": "Ver la cita en conflicto",
      "openOtherFailed": "No se pudo abrir la cita.",
      "saved": "Cita actualizada.",
      "created": "Cita creada.",
      "withWarning": "{{saved}} Atención: {{what}}.",
      "warningAnd": " y "
    },
    "history": {
      "title": "Historial",
      "loading": "Cargando el historial…",
      "error": "No se pudo cargar el historial.",
      "retry": "Reintentar",
      "empty": "No se registró nada antes de que se empezara a guardar el historial.",
      "beforeNote": "No se registró nada antes del primer elemento de esta lista.",
      "created": "Creada como {{status}}",
      "updated": "Cambiado: {{fields}}",
      "statusChange": "Estado: {{from}} → {{to}}",
      "reason": "Motivo: {{reason}}.",
      "by": "por {{name}}",
      "field": {
        "time": "horario",
        "duration": "duración",
        "professional": "profesional"
      }
    },
    "action": {
      "confirmed": "Confirmar",
      "arrived": "Marcar llegada",
      "in_progress": "Iniciar la atención",
      "completed": "Completar la atención",
      "cancelled": "Cancelar cita",
      "no_show": "Registrar inasistencia",
      "scheduled": "Volver a programada",
      "restore": "Restaurar cita"
    },
    "reason": {
      "cancel": {
        "patient_request": "Pedido del paciente",
        "clinic_request": "Pedido de la clínica",
        "professional_unavailable": "Profesional no disponible",
        "rescheduled_elsewhere": "Reprogramada en otro lugar",
        "other": "Otro motivo"
      },
      "noShow": {
        "no_contact": "Sin contacto",
        "patient_reported": "El paciente avisó",
        "other": "Otro motivo"
      }
    },
    "field": {
      "patient": "Paciente",
      "patientRequired": "Elige un paciente de la lista.",
      "patientEmpty": "Ningún paciente encontrado.",
      "patientFailed": "No se pudo buscar pacientes.",
      "status": "Estado inicial",
      "noShowReason": "Motivo de la inasistencia",
      "professional": "Profesional",
      "date": "Fecha",
      "start": "Inicio",
      "duration": "Duración",
      "durationMinutes": "Duración en minutos",
      "durationCustom": "Otra duración",
      "minutes": "{{n}} min",
      "errors": {
        "required": "Completa este campo.",
        "grid": "Usa horarios de 5 en 5 minutos.",
        "range": "La duración debe estar entre 5 y 480 minutos."
      }
    },
    "confirm": {
      "title": "Confirmar el horario",
      "message": "Este horario está {{what}}.",
      "saveAnyway": "Guardar de todos modos"
    },
    "warning": {
      "outside_opening_hours": "fuera del horario de funcionamiento de la clínica",
      "outside_working_hours": "fuera del horario laboral del profesional"
    },
    "error": {
      "appointment_warnings": "Este horario necesita confirmación.",
      "appointment_changed": "La cita fue modificada por otra persona. Ciérrala y ábrela de nuevo para ver la versión actual.",
      "appointment_conflict_professional": "Este profesional ya tiene otra cita en ese horario.",
      "appointment_conflict_patient": "Este paciente ya tiene otra cita en ese horario.",
      "schedule_blocked": "El horario cae en un bloqueo de la agenda.",
      "professional_not_eligible": "Este profesional no puede recibir citas.",
      "time_invalid": "Horario inválido. Revisa la fecha, el inicio y la duración.",
      "transition_not_allowed": "Este cambio de estado no está permitido.",
      "time_guard_failed": "Este cambio de estado no está permitido a esta hora.",
      "reason_required": "Elige un motivo.",
      "reason_invalid": "Elige un motivo válido.",
      "initial_status_invalid": "Este estado inicial no está permitido para el horario elegido.",
      "appointment_frozen": "Esta cita está finalizada y no se puede modificar.",
      "field_not_editable": "Este campo no se puede modificar en este estado.",
      "clinic_closed": "La clínica está cerrada; no se puede modificar la agenda.",
      "patient_archived": "La ficha de este paciente está archivada.",
      "appointment_not_found": "Cita no encontrada.",
      "patient_not_found": "Paciente no encontrado.",
      "unknown": "No se pudo completar. Inténtalo de nuevo."
    }
  },
  "hub.rebooking": {
    "title": "Reagendamientos pendientes",
    "subtitle": "Pacientes con cita cancelada o a la que no asistieron y sin nueva cita. Cada paciente sale de la lista al reagendarse o a los 30 días.",
    "loading": "Cargando la lista…",
    "loadFailed": "No se pudo cargar la lista.",
    "retry": "Intentar de nuevo",
    "noAccess": "No tienes acceso a la agenda de esta clínica.",
    "back": "Volver a la agenda",
    "listHeading": "Pacientes por reagendar",
    "listLabel": "Pacientes por reagendar",
    "empty": "Ningún paciente espera reagendamiento.",
    "professional": "Profesional",
    "allProfessionals": "Toda la clínica",
    "none": "Ningún paciente por reagendar",
    "count_one": "{{count}} paciente por reagendar",
    "count_other": "{{count}} pacientes por reagendar",
    "when": "{{weekday}}, {{date, date}}, {{start, time}} – {{end, time}}",
    "reason": "Motivo: {{reason}}",
    "next": "Próxima cita: {{date, date}}, {{time, time}}, {{professional}}",
    "rebook": "Reagendar",
    "rebookName": "Reagendar {{name}}",
    "more": "Cargar más",
    "moreFailed": "No se pudieron cargar más pacientes.",
    "loadedMore": "{{count}} pacientes en la lista",
    "cleared": "{{name}} fue reagendado(a) para el {{date, date}} a las {{time, time}}. Salió de la lista.",
    "stays": "Cita creada para {{name}} el {{date, date}} a las {{time, time}}. El paciente sigue en la lista: el nuevo horario no es posterior al de la cita perdida.",
    "created": "Cita creada.",
    "openOtherFailed": "No se pudo abrir la cita."
  },
  "hub.freeSlots": {
    "open": "Buscar horario libre",
    "title": "Buscar horario libre",
    "intro": "Elija el profesional y la duración para ver los próximos horarios en que se puede agendar sin aviso.",
    "professional": "Profesional",
    "duration": "Duración",
    "minutes": "{{n}} min",
    "results": "Horarios libres",
    "searching": "Buscando horarios libres…",
    "none": "No se encontró ningún horario libre",
    "found_one": "{{count}} horario libre encontrado",
    "found_other": "{{count}} horarios libres encontrados",
    "slot": "{{weekday}}, {{date, date}}, {{start, time}} a {{end, time}}",
    "empty": "No hay horarios libres en los próximos 14 días para este profesional y esta duración. Pruebe otra duración u otro profesional.",
    "failed": "No se pudo buscar los horarios libres.",
    "retry": "Intentar de nuevo",
    "noProfessionals": "Ningún profesional puede recibir citas en esta clínica.",
    "close": "Cerrar"
  },
  "hub.clinics": {
    "title": "Mis clínicas",
    "empty": "Todavía no formas parte de ninguna clínica.",
    "closed": "Cerrada",
    "roles": {
      "owner": "Propietario",
      "dentist": "Dentista"
    }
  },
  "hub.myClinicsLoad": {
    "loading": "Cargando tus clínicas…",
    "loadFailed": "No se pudieron cargar tus clínicas.",
    "retry": "Reintentar"
  },
  "hub.home": {
    "title": "Inicio"
  },
  "hub.login": {
    "forgot": "¿Olvidaste la contraseña?",
    "title": "Iniciar sesión",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "submit": "Entrar",
    "passwordSet": "Contraseña definida. Inicia sesión con la nueva contraseña.",
    "error": {
      "invalid": "Correo o contraseña incorrectos.",
      "throttled": "Demasiados intentos. Espera un minuto e inténtalo de nuevo.",
      "generic": "No se pudo iniciar sesión. Inténtalo de nuevo."
    }
  },
  "hub.notFound": {
    "title": "Página no encontrada",
    "message": "La página que buscas no existe o fue movida.",
    "home": "Ir al inicio"
  },
  "hub.patientHealth": {},
  "hub.patientRecord": {
    "title": "Ficha del paciente",
    "loading": "Cargando la ficha del paciente…",
    "failed": "No se pudo cargar la ficha. Inténtelo de nuevo.",
    "notFound": {
      "title": "Paciente no encontrado",
      "message": "Esta ficha no existe o no pertenece a esta clínica.",
      "back": "Volver a la lista de pacientes"
    },
    "breadcrumb": {
      "label": "Usted está en",
      "patients": "Pacientes"
    },
    "archivedBanner": "Ficha archivada el {{at}} por {{name}}. Motivo: {{reason}}. Solo lectura.",
    "more": {
      "label": "Más acciones",
      "text": "Más",
      "archive": "Archivar ficha",
      "unarchive": "Desarchivar ficha"
    },
    "archive": {
      "title": "Archivar ficha",
      "body": "La ficha queda de solo lectura y sale de la lista por defecto. Puede desarchivarla después.",
      "reason": "Motivo",
      "placeholder": "Seleccione un motivo",
      "required": "Elija un motivo.",
      "confirm": "Archivar",
      "failed": "No se pudo archivar. Inténtelo de nuevo.",
      "futureAppointments_one": "Este paciente tiene {{count}} cita futura. Cancélela o reprográmela antes de archivar.",
      "futureAppointments_many": "Este paciente tiene {{count}} de citas futuras. Cancélelas o reprográmelas antes de archivar.",
      "futureAppointments_other": "Este paciente tiene {{count}} citas futuras. Cancélelas o reprográmelas antes de archivar.",
      "cancel": "Cancelar",
      "reasons": {
        "left_clinic": "Dejó la clínica",
        "deceased": "Fallecimiento",
        "duplicate": "Ficha duplicada",
        "created_by_mistake": "Creada por error",
        "other": "Otro"
      }
    },
    "unarchive": {
      "title": "Desarchivar ficha",
      "body": "La ficha vuelve a ser editable y a aparecer en la lista.",
      "confirm": "Desarchivar",
      "failed": "No se pudo desarchivar. Inténtelo de nuevo.",
      "done": "Ficha desarchivada."
    },
    "archivedBadge": "Archivado",
    "header": {
      "civilName": "Nombre civil: {{name}}",
      "age_one": "{{count}} año",
      "age_other": "{{count}} años",
      "cpf": "CPF {{cpf}}",
      "whatsapp": "WhatsApp",
      "noContact": "Sin teléfono ni correo",
      "noticePending": "Aviso de privacidad pendiente"
    },
    "tabs": {
      "label": "Secciones de la ficha",
      "later": "{{tab}} (próximamente: proyecto {{project}})",
      "overview": "Resumen",
      "health": "Salud",
      "appointments": "Citas",
      "clinical": "Historia clínica",
      "images": "Imágenes",
      "plans": "Planes de tratamiento",
      "finance": "Finanzas",
      "privacy": "Privacidad",
      "projects": {
        "agenda": "Agenda",
        "clinical": "Historia clínica",
        "images": "Imágenes",
        "plans": "Procedimientos y planes",
        "finance": "Finanzas"
      }
    },
    "overview": {
      "notProvided": "No informado",
      "edit": "Editar",
      "editCard": "Editar {{card}}",
      "saved": "{{card}} guardado.",
      "underageHint": "Paciente menor de 18 años sin responsable registrado.",
      "notesHint": "Sin información de salud aquí; use la pestaña de salud.",
      "yes": "Sí",
      "no": "No",
      "cards": {
        "identification": "Identificación",
        "contact": "Contacto y dirección",
        "guardian": "Responsable",
        "notes": "Observaciones administrativas"
      }
    },
    "fields": {
      "name": "Nombre civil",
      "socialName": "Nombre social",
      "sex": "Sexo",
      "birthDate": "Fecha de nacimiento",
      "cpf": "CPF",
      "rg": "RG",
      "foreignDocument": "Documento extranjero",
      "nationality": "Nacionalidad (código de país, p. ej. BR)",
      "foreign": "Paciente extranjero",
      "maritalStatus": "Estado civil",
      "profession": "Profesión",
      "phone": "Teléfono",
      "phoneHasWhatsapp": "Este teléfono tiene WhatsApp",
      "email": "Correo electrónico",
      "postalCode": "Código postal (CEP)",
      "street": "Calle",
      "number": "Número",
      "complement": "Complemento",
      "district": "Barrio",
      "state": "Estado (UF)",
      "cityIbgeCode": "Ciudad",
      "guardianName": "Nombre del responsable",
      "guardianCpf": "CPF del responsable",
      "guardianPhone": "Teléfono del responsable",
      "guardianRelationship": "Parentesco",
      "notes": "Observaciones"
    },
    "address": {
      "search": "Buscar",
      "noResults": "Sin resultados.",
      "cityNeedsState": "Elija primero el estado."
    },
    "options": {
      "none": "No informado",
      "sex": {
        "female": "Femenino",
        "male": "Masculino",
        "intersex": "Intersexo"
      },
      "marital": {
        "single": "Soltero(a)",
        "married": "Casado(a)",
        "stable_union": "Unión estable",
        "separated": "Separado(a)",
        "divorced": "Divorciado(a)",
        "widowed": "Viudo(a)"
      }
    },
    "form": {
      "title": "Editar {{card}}",
      "save": "Guardar",
      "saveAnyway": "Guardar de todos modos",
      "cancel": "Cancelar",
      "open": "Abrir ficha",
      "errors": {
        "required": "Complete este campo.",
        "cpfInvalid": "CPF inválido. Revise los 11 dígitos.",
        "birthDateInvalid": "Fecha inválida. Use una fecha entre 1900 y hoy.",
        "phoneInvalid": "Teléfono inválido. Indique el código de área, o el código de país con +.",
        "emailInvalid": "Correo inválido.",
        "postalCodeInvalid": "Código postal inválido. Indique 8 dígitos.",
        "cityNotInState": "Elija una ciudad del estado seleccionado.",
        "countryInvalid": "Indique 2 letras, como BR.",
        "notesTooLong": "Use como máximo 2000 caracteres.",
        "contactRequired": "Indique un teléfono o un correo.",
        "cpfTaken": "Este CPF ya está registrado para {{name}}.",
        "cpfTakenArchived": "Este CPF ya está registrado para {{name}} (ficha archivada)."
      },
      "failed": "No se pudo guardar. Inténtelo de nuevo.",
      "archived": "Esta ficha fue archivada y ya no se puede editar.",
      "duplicates": {
        "title": "Existen fichas parecidas",
        "body": "Revise antes de guardar. El botón ahora es “Guardar de todos modos”.",
        "nameBirthDate": "mismo nombre y fecha de nacimiento",
        "phone": "mismo teléfono",
        "archivedTag": "archivado",
        "open": "Abrir la ficha de {{name}}"
      }
    }
  },
  "hub.patientAlerts": {
    "title": "Alertas clínicas",
    "empty": "Ninguna alerta clínica.",
    "meta": "{{name}} el {{at}}",
    "add": "Añadir alerta",
    "resolve": "Resolver",
    "resolveLabel": "Resolver alerta: {{text}}",
    "resolved": "Alerta resuelta.",
    "added": "Alerta añadida.",
    "chips": "Alertas clínicas activas",
    "addDialog": {
      "title": "Añadir alerta clínica",
      "text": "Alerta",
      "hint": "Un aviso corto para todo el equipo, como “Alergia a la penicilina”. Hasta 500 caracteres.",
      "save": "Añadir",
      "cancel": "Cancelar",
      "required": "Escriba la alerta.",
      "tooLong": "Use como máximo 500 caracteres.",
      "failed": "No se pudo añadir la alerta. Inténtelo de nuevo.",
      "archived": "Esta ficha fue archivada y ya no se puede modificar."
    },
    "resolveDialog": {
      "title": "Resolver alerta clínica",
      "body": "Esta alerta dejará de aparecer en la ficha: “{{text}}”",
      "confirm": "Resolver alerta",
      "cancel": "Cancelar",
      "failed": "No se pudo resolver la alerta. Inténtelo de nuevo.",
      "archived": "Esta ficha fue archivada y ya no se puede modificar."
    }
  },
  "hub.patientPrivacy": {
    "title": "Privacidad y LGPD",
    "intro": "Base legal, aviso de privacidad y consentimientos de este paciente. Nada aquí bloquea la atención.",
    "loading": "Cargando la privacidad…",
    "failed": "No se pudo cargar la privacidad. Inténtelo de nuevo.",
    "saved": "Registro guardado.",
    "none": "Sin registro",
    "basis": {
      "title": "Base legal de la ficha",
      "none": "Ninguna base legal registrada.",
      "summary": "{{basis}}, desde {{date}}, registrada por {{name}}.",
      "change": "Cambiar base legal",
      "options": {
        "health_protection": "Tutela de la salud",
        "legal_obligation": "Obligación legal o regulatoria",
        "contract": "Ejecución de contrato",
        "consent": "Consentimiento",
        "other_documented": "Otra, documentada"
      }
    },
    "notice": {
      "title": "Aviso de privacidad",
      "none": "Aún no se registró la lectura del aviso. La atención sigue con normalidad.",
      "summary": "Lectura registrada el {{date}}: {{givenBy}}, {{channel}}. Registrada por {{name}}.",
      "record": "Registrar lectura del aviso",
      "recordAgain": "Registrar nueva lectura"
    },
    "consents": {
      "title": "Consentimientos más allá de la atención",
      "hint": "La ficha no depende de consentimiento. Registre aquí solo usos opcionales.",
      "purposeLabel": "Finalidad",
      "stateLabel": "Situación",
      "given": "Otorgado el {{date}}",
      "withdrawn": "Retirado el {{date}}",
      "give": "Registrar consentimiento",
      "giveFor": "Registrar consentimiento: {{purpose}}",
      "withdraw": "Registrar retiro",
      "withdrawFor": "Registrar retiro: {{purpose}}",
      "purposes": {
        "care_record": "Ficha clínica",
        "marketing": "Comunicaciones de marketing",
        "case_showcase_images": "Difusión de imágenes de casos",
        "research": "Investigación"
      }
    },
    "history": {
      "summary": "Historial ({{count}})",
      "empty": "Ningún evento registrado.",
      "kinds": {
        "legal_basis_set": "Base legal definida: {{basis}}",
        "notice_acknowledged": "Lectura del aviso registrada",
        "consent_given": "Consentimiento otorgado: {{purpose}}",
        "consent_withdrawn": "Consentimiento retirado: {{purpose}}"
      },
      "meta": "{{date}}, por {{name}}",
      "wording": "Versión del texto: {{version}}"
    },
    "givenBy": {
      "patient": "el paciente",
      "guardian": "el responsable legal"
    },
    "channel": {
      "written": "por escrito",
      "electronic": "por medio electrónico"
    },
    "form": {
      "titles": {
        "legal_basis_set": "Cambiar base legal",
        "notice_acknowledged": "Registrar lectura del aviso",
        "consent_given": "Registrar consentimiento: {{purpose}}",
        "consent_withdrawn": "Registrar retiro: {{purpose}}"
      },
      "basis": "Base legal",
      "givenBy": "Quién lo informó",
      "channel": "Cómo se registró",
      "wording": "Versión del texto presentado",
      "occurredOn": "Fecha",
      "note": "Observación",
      "noteHint": "Sin información de salud aquí.",
      "submit": "Registrar",
      "cancel": "Cancelar",
      "errors": {
        "dateRequired": "Indique la fecha.",
        "dateFuture": "La fecha no puede ser futura.",
        "noteRequired": "Explique la base documentada.",
        "noteTooLong": "Use como máximo 500 caracteres."
      },
      "failed": "No se pudo registrar. Inténtelo de nuevo.",
      "noConsent": "No hay consentimiento otorgado para retirar en esa fecha."
    }
  },
  "hub.patientCreate": {
    "title": "Nuevo paciente",
    "save": "Guardar",
    "saveAnyway": "Guardar de todos modos",
    "cancel": "Cancelar",
    "openUnarchive": "Abrir y desarchivar",
    "failed": "No se pudo registrar al paciente. Inténtalo de nuevo.",
    "loading": "Cargando…",
    "loadFailed": "No se pudo cargar el formulario. Inténtalo de nuevo.",
    "noAccess": "No tienes permiso para registrar pacientes.",
    "toast": {
      "title": "Paciente registrado"
    }
  },
  "hub.patientList": {
    "title": "Pacientes",
    "subtitle": "Registro de pacientes de la clínica.",
    "new": "Nuevo paciente",
    "filter": {
      "label": "Estado",
      "active": "Activos",
      "all": "Incluir archivados"
    },
    "search": {
      "label": "Buscar paciente",
      "placeholder": "Buscar por nombre, CPF o teléfono…"
    },
    "sort": {
      "menu": "Ordenar: {{current}}",
      "label": "Ordenar por",
      "name": "Nombre (A–Z)",
      "createdAt": "Añadidos recientemente",
      "updatedAt": "Actualizados recientemente"
    },
    "col": {
      "patient": "Paciente",
      "contact": "Contacto",
      "cpf": "CPF",
      "actions": "Acciones"
    },
    "birthDate": "Nacimiento: {{date}}",
    "birthDateMissing": "Nacimiento no informado",
    "contactMissing": "No informado",
    "cpfMissing": "No informado",
    "archived": "Archivado",
    "open": "Ver ficha",
    "openFor": "Ver ficha de {{name}}",
    "loadMore": "Cargar más",
    "loading": "Cargando pacientes…",
    "empty": {
      "title": "Ningún paciente registrado",
      "hint": "Registra al primer paciente de la clínica."
    },
    "noResults": {
      "title": "Ningún paciente encontrado",
      "hint": "Prueba otro término.",
      "hintArchived": "Prueba otro término o incluye los archivados."
    },
    "announce": {
      "shown_one": "{{count}} paciente mostrado",
      "shown_other": "{{count}} pacientes mostrados",
      "loadedMore_one": "{{count}} paciente cargado, {{shown}} mostrados",
      "loadedMore_other": "{{count}} pacientes cargados, {{shown}} mostrados",
      "none": "Ningún paciente encontrado"
    },
    "error": {
      "load": "No se pudieron cargar los pacientes. Inténtalo de nuevo.",
      "more": "No se pudieron cargar más pacientes. Inténtalo de nuevo."
    }
  },
  "hub.clinicSettings": {
    "title": "Configuración de la clínica",
    "subtitle": "Horario de atención e identidad de la clínica.",
    "loading": "Cargando configuración…",
    "loadFailed": "No se pudo cargar la configuración de la clínica.",
    "retry": "Reintentar",
    "notInformed": "No informado",
    "weekday": {
      "1": "Lunes",
      "2": "Martes",
      "3": "Miércoles",
      "4": "Jueves",
      "5": "Viernes",
      "6": "Sábado",
      "7": "Domingo"
    },
    "common": {
      "cancel": "Cancelar",
      "save": "Guardar"
    },
    "hours": {
      "title": "Horario de atención",
      "tableLabel": "Horario de atención por día",
      "colDay": "Día",
      "colHours": "Horario",
      "closed": "Cerrado",
      "interval": "{{opensAt, time}} a {{closesAt, time}}",
      "notSet": "Sin definir",
      "notSetOwner": "El horario de atención aún no se definió. Mientras tanto, la agenda muestra de {{from, time}} a {{to, time}} y no avisa sobre horarios fuera del horario de atención.",
      "notSetMember": "El propietario de la clínica aún no definió el horario de atención. Mientras tanto, la agenda muestra de {{from, time}} a {{to, time}}.",
      "define": "Definir horario",
      "edit": "Editar horario",
      "saved": "Horario de atención guardado",
      "form": {
        "opens": "Abre a las",
        "closes": "Cierra a las",
        "add": "Agregar intervalo",
        "addFor": "Agregar intervalo: {{day}}",
        "remove": "Quitar",
        "removeFor": "Quitar intervalo, {{day}}, {{opensAt, time}} a {{closesAt, time}}",
        "removeBlankFor": "Quitar intervalo {{n}} sin horario, {{day}}",
        "caption": "Horario de atención, un intervalo por fila",
        "colActions": "Acciones",
        "opensFor": "Abre a las, {{day}}",
        "closesFor": "Cierra a las, {{day}}",
        "intervalSuffix": ", intervalo {{n}}",
        "hint": "Usa horarios de 5 en 5 minutos. Para una pausa de almuerzo, agrega dos intervalos el mismo día. Un día sin intervalos queda cerrado.",
        "failed": "No se pudo guardar el horario. Inténtalo de nuevo.",
        "errors": {
          "week": "Indica al menos un intervalo de atención.",
          "incomplete": "Indica la hora de apertura y de cierre.",
          "grid": "Usa horarios de 5 en 5 minutos.",
          "order": "El cierre debe ser después de la apertura.",
          "overlap": "Este intervalo se superpone con otro del mismo día."
        }
      }
    },
    "identity": {
      "title": "Identidad de la clínica",
      "edit": "Editar identidad",
      "saved": "Identidad de la clínica guardada",
      "hint": "Los datos que imprimen los documentos de la clínica. Todos son opcionales.",
      "whatsapp": "WhatsApp",
      "cro": "CRO {{number}}/{{uf}}",
      "croNoUf": "CRO {{number}}",
      "form": {
        "failed": "No se pudo guardar la identidad. Inténtalo de nuevo.",
        "whatsapp": "Este teléfono tiene WhatsApp",
        "none": "Ninguno",
        "candidate": "{{name}} — CRO {{cro}}",
        "managerHint": "Elige entre los miembros con la función de dentista y CRO registrado.",
        "managerNone": "Ningún miembro es dentista con CRO registrado.",
        "cityNeedsState": "Elige primero el estado.",
        "search": "Buscar",
        "noResults": "Sin resultados.",
        "errors": {
          "required": "Indica el nombre comercial.",
          "cnpjLength": "CNPJ incompleto. Indica los 14 caracteres.",
          "cnpjChecksum": "CNPJ no válido. Los dígitos de control no coinciden, revisa el número.",
          "phoneInvalid": "Teléfono no válido. Indica el código de área y el número.",
          "emailInvalid": "Correo no válido.",
          "postalCodeInvalid": "CEP no válido. Indica los 8 dígitos.",
          "cityNeedsState": "Elige un municipio del estado seleccionado."
        }
      },
      "fields": {
        "name": "Nombre comercial",
        "legalName": "Razón social",
        "cnpj": "CNPJ",
        "croRegistration": "Registro CRO de la clínica",
        "phone": "Teléfono",
        "email": "Correo electrónico",
        "address": "Dirección",
        "postalCode": "CEP",
        "street": "Calle",
        "number": "Número",
        "complement": "Complemento",
        "district": "Barrio",
        "state": "Estado",
        "city": "Ciudad",
        "technicalManager": "Responsable técnico"
      }
    }
  },
  "hub.schedule": {
    "title": "Horarios y bloqueos",
    "loading": "Cargando horarios y bloqueos…",
    "loadFailed": "No se pudieron cargar los horarios y bloqueos.",
    "retry": "Intentar de nuevo",
    "close": "Cerrar",
    "back": "Volver",
    "cancel": "Cancelar",
    "save": "Guardar",
    "weekday": {
      "1": "Lunes",
      "2": "Martes",
      "3": "Miércoles",
      "4": "Jueves",
      "5": "Viernes",
      "6": "Sábado",
      "7": "Domingo"
    },
    "reason": {
      "vacation": "Vacaciones",
      "absence": "Ausencia",
      "training": "Capacitación",
      "holiday": "Feriado",
      "closure": "Cierre",
      "other": "Otro"
    },
    "status": {
      "scheduled": "Agendada",
      "confirmed": "Confirmada",
      "arrived": "Llegó",
      "in_progress": "En atención",
      "completed": "Concluida",
      "cancelled": "Cancelada",
      "no_show": "No asistió"
    },
    "hours": {
      "title": "Horario de atención",
      "professional": "Profesional",
      "noProfessionals": "No hay profesionales activos en esta clínica.",
      "notSet": "Sin definir",
      "notSetText": "{{name}} no tiene horario propio y sigue el horario de funcionamiento de la clínica.",
      "tableLabel": "Horario de atención por día",
      "colDay": "Día",
      "colHours": "Horario",
      "closed": "No atiende",
      "interval": "{{opensAt, time}} a {{closesAt, time}}",
      "define": "Definir horario",
      "edit": "Editar horario",
      "saved": "Horario de atención guardado",
      "form": {
        "title": "Horario de atención: {{name}}",
        "hint": "Use intervalos de 5 en 5 minutos. Para una pausa de almuerzo, agregue dos intervalos el mismo día. Un día sin intervalos es un día en que el profesional no atiende. El horario puede quedar fuera del funcionamiento de la clínica.",
        "opens": "Empieza a las",
        "closes": "Termina a las",
        "add": "Agregar intervalo",
        "addFor": "Agregar intervalo: {{day}}",
        "remove": "Quitar",
        "removeFor": "Quitar intervalo, {{day}}, {{opensAt, time}} a {{closesAt, time}}",
        "removeBlankFor": "Quitar intervalo {{n}} sin horario, {{day}}",
        "caption": "Horario de atención del profesional, un intervalo por fila",
        "colActions": "Acciones",
        "opensFor": "Empieza a las, {{day}}",
        "closesFor": "Termina a las, {{day}}",
        "intervalSuffix": ", intervalo {{n}}",
        "failed": "No se pudo guardar el horario. Intente de nuevo.",
        "forbidden": "No puede cambiar el horario de este profesional.",
        "notEligible": "Este profesional ya no atiende en esta clínica.",
        "errors": {
          "week": "Indique al menos un intervalo de atención.",
          "incomplete": "Indique el inicio y el fin.",
          "grid": "Use intervalos de 5 en 5 minutos.",
          "order": "El fin debe ser posterior al inicio.",
          "overlap": "Este intervalo se superpone con otro del mismo día."
        }
      }
    },
    "blocks": {
      "title": "Bloqueos",
      "new": "Nuevo bloqueo",
      "empty": "No hay bloqueos futuros.",
      "clinic": "Toda la clínica",
      "showPast": "Ver bloqueos pasados",
      "pastTitle": "Bloqueos pasados",
      "pastEmpty": "No hay bloqueos pasados.",
      "pastFailed": "No se pudieron cargar los bloqueos pasados.",
      "edit": "Editar",
      "editFor": "Editar bloqueo: {{who}}, {{dates}}",
      "remove": "Eliminar",
      "removeFor": "Eliminar bloqueo: {{who}}, {{dates}}",
      "reasonLabel": "{{reason}}: {{label}}",
      "dates": {
        "day": "{{date}}",
        "days": "{{start}} a {{end}}",
        "timed": "{{date}}, {{start, time}} a {{end, time}}",
        "timedDays": "{{startDate}} {{start, time}} a {{endDate}} {{end, time}}"
      },
      "created": "Bloqueo creado",
      "updated": "Bloqueo guardado",
      "deleted": "Bloqueo eliminado",
      "form": {
        "titleNew": "Nuevo bloqueo",
        "titleEdit": "Editar bloqueo",
        "who": "Quién",
        "reason": "Motivo",
        "label": "Descripción (opcional)",
        "labelHint": "Aparece en la agenda. No escriba datos de salud ni de pacientes.",
        "allDay": "Día(s) completo(s)",
        "firstDay": "Primer día",
        "lastDay": "Último día",
        "startDate": "Fecha inicial",
        "startTime": "Hora inicial",
        "endDate": "Fecha final",
        "endTime": "Hora final",
        "create": "Crear bloqueo",
        "save": "Guardar bloqueo",
        "failed": "No se pudo guardar el bloqueo. Intente de nuevo.",
        "forbidden": "No puede cambiar este bloqueo.",
        "notEligible": "Este profesional ya no atiende en esta clínica.",
        "notFound": "Este bloqueo ya no existe. Cierre y abra de nuevo.",
        "errors": {
          "required": "Complete este campo.",
          "grid": "Use intervalos de 5 en 5 minutos.",
          "order": "La fecha final debe ser igual o posterior a la inicial.",
          "orderTime": "La hora final debe ser posterior a la inicial.",
          "invalid": "Esta hora no existe en la zona horaria de la clínica.",
          "labelTooLong": "La descripción puede tener como máximo 80 caracteres."
        }
      },
      "warn": {
        "title_one": "Este bloqueo cubre {{count}} cita",
        "title_other": "Este bloqueo cubre {{count}} citas",
        "hint": "Las citas siguen como están y pasan a aparecer como \"en un bloqueo\". Mueva o cancele cada una después.",
        "listLabel": "Citas cubiertas",
        "item": "{{date}}, {{start, time}} a {{end, time}}: {{patient}} con {{professional}} ({{status}})",
        "more_one": "y {{count}} cita más",
        "more_other": "y {{count}} citas más",
        "confirmCreate": "Crear de todos modos",
        "confirmSave": "Guardar de todos modos",
        "adjust": "Volver y ajustar"
      },
      "delete": {
        "title": "¿Eliminar bloqueo?",
        "body": "El bloqueo {{summary}} se eliminará y el horario vuelve a quedar disponible.",
        "confirm": "Eliminar",
        "failed": "No se pudo eliminar el bloqueo. Intente de nuevo."
      }
    }
  },
  "public.header": {
    "login": "Iniciar sesión"
  },
  "public.shell": {
    "skipToContent": "Saltar al contenido"
  },
  "public.accessibility": {
    "title": "Declaración de accesibilidad",
    "commitment": {
      "title": "Nuestro compromiso",
      "body": "Takove quiere que el sistema pueda ser usado por todas las personas, incluidas las personas con discapacidad y quienes usan lector de pantalla, teclado o ampliación de pantalla."
    },
    "standard": {
      "title": "Estándar y evaluación",
      "body": "Buscamos seguir las WCAG 2.2, nivel AA. Esta es una autoevaluación; el sistema aún no ha pasado por una auditoría independiente y no declaramos conformidad."
    },
    "gaps": {
      "title": "Limitaciones conocidas",
      "body": "Estamos reconstruyendo la interfaz. Hoy el área pública tiene solo la página de inicio, esta declaración y la página de error, y no conocemos barreras en ellas. Las pantallas del área restringida, como la agenda más abajo, y las demás pantallas llegan a medida que se reconstruyen, con las mismas verificaciones automáticas, que no sustituyen una auditoría independiente.",
      "agenda": "La agenda de la clínica (área restringida, en las vistas de lista y de cuadrícula) pasa por verificaciones automáticas (axe, WCAG 2.2 AA) y pruebas de teclado. Aún no se ha probado con lectores de pantalla (VoiceOver y NVDA) ni en dispositivos reales con zoom. La cuadrícula es una tabla de botones, sin el rol ARIA de cuadrícula, hasta que se haga esa prueba; la lista es la alternativa y la vista por defecto en pantallas pequeñas."
    },
    "contact": {
      "title": "Contacto",
      "body": "¿Encontraste una barrera o necesitas otro formato? Escribe a:"
    },
    "lastReviewed": "Última revisión: 30 de octubre de 2026"
  },
  "public.home": {
    "hero": {
      "title": "Hola, mundo",
      "tagline": "Fastify + React + daisyUI"
    }
  },
  "public.notFound": {
    "title": "Página no encontrada",
    "message": "La página que buscas no existe o fue movida.",
    "home": "Ir al inicio"
  },
  "app.footer": {
    "tagline": "Una entrada sencilla para encontrar atención, profesionales y productos.",
    "navigation": "Enlaces del pie de página",
    "accessibility": "Accesibilidad",
    "hub": "Hub",
    "admin": "Admin",
    "build": "Versión {{id}}"
  },
  "app.brand": {
    "name": "Takove"
  },
  "forgotPassword": {
    "title": "¿Olvidaste la contraseña?",
    "intro": "Indica el correo de tu cuenta y te enviaremos un enlace para definir una nueva contraseña.",
    "email": "Correo electrónico",
    "submit": "Enviar enlace",
    "back": "Volver a iniciar sesión",
    "sent": "Si existe una cuenta para esta dirección, enviamos un enlace.",
    "error": {
      "throttled": "Demasiados intentos. Espera unos minutos e inténtalo de nuevo.",
      "failed": "No se pudo enviar el enlace. Inténtalo de nuevo."
    }
  },
  "setPassword": {
    "title": "Definir contraseña",
    "checking": "Comprobando el enlace…",
    "email": "Correo electrónico",
    "password": "Nueva contraseña",
    "confirm": "Confirmar nueva contraseña",
    "submit": "Definir contraseña",
    "invalid": {
      "title": "Enlace no válido o caducado",
      "message": "Este enlace para definir la contraseña no es válido o ha caducado.",
      "forgot": "Solicitar un nuevo enlace"
    },
    "error": {
      "tooShort": "La contraseña debe tener al menos {{min}} caracteres.",
      "mismatch": "Las contraseñas no coinciden.",
      "throttled": "Demasiados intentos. Espera un minuto e inténtalo de nuevo.",
      "generic": "No se pudo definir la contraseña. Inténtalo de nuevo."
    }
  },
  "i18n.localeSelect": {
    "label": "Idioma"
  },
  "common": {
    "save": "Guardar",
    "cancel": "Cancelar",
    "edit": "Editar",
    "delete": "Eliminar",
    "close": "Cerrar",
    "loading": "Cargando…",
    "errorBoundary": {
      "title": "Algo salió mal",
      "message": "Ocurrió un error inesperado. Intenta recargar la página.",
      "reload": "Recargar la página",
      "home": "Ir al inicio"
    }
  }
}
